import { type SupplierListItem } from '@choco-admin/types';
import { Card, CardBody, Button, Switch, Divider, Input } from '@heroui/react';
import React, { useState } from 'react';

interface SettingsTabProps {
  supplier?: SupplierListItem;
  mode: 'create' | 'edit';
}

export const SettingsTab: React.FC<SettingsTabProps> = ({ supplier, mode }) => {
  const [isEnabled, setIsEnabled] = useState(true);
  const [isDiscoverable, setIsDiscoverable] = useState(true);
  const [isIntegrated, setIsIntegrated] = useState(
    supplier?.isIntegrated || false
  );
  const [referenceId, setReferenceId] = useState(supplier?.referenceId || '');

  return (
    <div className="max-w-4xl space-y-6">
      <Card>
        <CardBody>
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-foreground">
                  Enable Supplier
                </h3>
                <p className="text-sm text-default-500">
                  Enable or disable this supplier account
                </p>
              </div>
              <Switch
                isSelected={isEnabled}
                onValueChange={setIsEnabled}
                size="lg"
              />
            </div>

            <Divider />

            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-foreground">
                  Discoverable
                </h3>
                <p className="text-sm text-default-500">
                  Make this supplier visible in search results
                </p>
              </div>
              <Switch
                isSelected={isDiscoverable}
                onValueChange={setIsDiscoverable}
                size="lg"
              />
            </div>

            <Divider />

            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-foreground">
                  Integration Status
                </h3>
                <p className="text-sm text-default-500">
                  Mark this supplier as integrated with external systems
                </p>
              </div>
              <Switch
                isSelected={isIntegrated}
                onValueChange={setIsIntegrated}
                size="lg"
              />
            </div>

            <Divider />

            <div>
              <h3 className="text-lg font-semibold text-foreground mb-4">
                Reference ID
              </h3>
              <Input
                value={referenceId}
                onChange={(e) => setReferenceId(e.target.value)}
                placeholder="Enter reference ID"
                classNames={{
                  input: 'bg-gray-50',
                  inputWrapper: 'bg-gray-50',
                }}
              />
              <p className="mt-2 text-sm text-default-500">
                This ID is used for internal reference and integrations
              </p>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Save Button */}
      <div className="flex justify-end">
        <Button color="primary" size="lg" className="px-8">
          {mode === 'create' ? 'CREATE SUPPLIER' : 'SAVE CHANGES'}
        </Button>
      </div>
    </div>
  );
};
